export default {"src":"/_next/static/media/american_express_logo.svg.664b3bc0.svg","height":16,"width":254,"blurWidth":0,"blurHeight":0};